import styled from "styled-components";

export const Section = styled.div<{backgroundColor?: string, backgroundImage?: string, backgroundImageFallback?: string, backgroundRadial?: Array<string>}>`
    ${props => props.backgroundColor && `background-color: ${props.backgroundColor};`}
    ${props => props.backgroundImage && `background-image: url(${props.backgroundImage}) ${props.backgroundImageFallback ? `, url(${props.backgroundImageFallback})` : ``} ;`}
    ${props => props.backgroundRadial && `background: radial-gradient(${props.backgroundRadial[0]}, ${props.backgroundRadial[1]});`}
`;